/* eslint-disable no-unused-vars */
export enum ButtonType {
    Button1,
    Button2,
    Button3,
    Button4,
}
